import * as React from 'react';

export const externalLinkIcon: JSX.Element = (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14 3H21V10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M21 3L11 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M19 14V19C19 20.1046 18.1046 21 17 21H5C3.89543 21 3 20.1046 3 19V7C3 5.89543 3.89543 5 5 5H10"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const collapseIcon: JSX.Element = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="0.5" width="23" height="23" rx="3.5" stroke="#00818A" />
        <path
            d="M12.3635 9.90235C12.1659 10.1122 11.8323 10.1119 11.635 9.90181L8.93998 7.03164C8.5765 6.64455 7.96209 6.64346 7.59726 7.02927C7.26182 7.38399 7.26084 7.93864 7.59502 8.29453L11.6346 12.5966C11.832 12.8069 12.166 12.8069 12.3635 12.5966L16.4085 8.29058C16.741 7.93662 16.7411 7.38517 16.4086 7.03114C16.0457 6.64461 15.432 6.64416 15.0684 7.03016L12.3635 9.90235Z"
            fill="#00818A"
        />
        <path
            d="M12.3635 15.2357C12.1659 15.4455 11.8323 15.4452 11.635 15.2351L8.93998 12.3649C8.5765 11.9779 7.96209 11.9768 7.59726 12.3626C7.26182 12.7173 7.26084 13.2719 7.59502 13.6278L11.6346 17.9299C11.832 18.1402 12.166 18.1402 12.3635 17.9299L16.4085 13.6239C16.741 13.2699 16.7411 12.7185 16.4086 12.3645C16.0457 11.9779 15.432 11.9775 15.0684 12.3635L12.3635 15.2357Z"
            fill="#00818A"
        />
    </svg>
);

export const expandIcon: JSX.Element = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="0.5" width="23" height="23" rx="3.5" fill="#00818A" stroke="#00818A" />
        <path
            d="M11.6365 9.08233C11.8341 8.87251 12.1677 8.87276 12.365 9.08287L15.06 11.953C15.4235 12.3401 16.0379 12.3412 16.4027 11.9554C16.7382 11.6007 16.7392 11.046 16.405 10.6901L12.3654 6.38812C12.168 6.17783 11.834 6.1778 11.6365 6.38805L7.59149 10.6941C7.25899 11.0481 7.25893 11.5995 7.59136 11.9535C7.95431 12.3401 8.56803 12.3405 8.93155 11.9545L11.6365 9.08233Z"
            fill="white"
        />
        <path
            d="M11.6365 14.4156C11.8341 14.2058 12.1677 14.2061 12.365 14.4162L15.06 17.2864C15.4235 17.6734 16.0379 17.6745 16.4027 17.2887C16.7382 16.934 16.7392 16.3794 16.405 16.0235L12.3654 11.7214C12.168 11.5111 11.834 11.5111 11.6365 11.7214L7.59149 16.0274C7.25899 16.3814 7.25893 16.9328 7.59136 17.2868C7.95431 17.6734 8.56803 17.6738 8.93155 17.2878L11.6365 14.4156Z"
            fill="white"
        />
    </svg>
);

export const expiredIcon: JSX.Element = (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="8" cy="8" r="6" transform="matrix(1 0 0 -1 0 16.5)" stroke="#A20000" strokeWidth="4" />
    </svg>
);

export const validIcon: JSX.Element = (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="8" cy="8" r="6" stroke="#66AC8E" strokeWidth="4" />
    </svg>
);
export const rcSvg = (
    <svg width="40" height="40" viewBox="8 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="19.9551" cy="20.0764" r="11" fill="#DA9000" fillOpacity="0.1" stroke="#DA9000" strokeWidth="2" />
        <path
            d="M18.9485 21.0464C18.9331 21.5036 18.558 21.8662 18.1006 21.8662C17.6431 21.8662 17.2681 21.5036 17.2526 21.0464L17.0827 16.0024C17.0636 15.4373 17.5166 14.9688 18.0821 14.9688H18.1191C18.6845 14.9688 19.1375 15.4373 19.1185 16.0024L18.9485 21.0464ZM18.1006 22.9463C18.4333 22.9463 18.6999 23.0443 18.9004 23.2402C19.1055 23.4362 19.208 23.6868 19.208 23.9922C19.208 24.293 19.1055 24.5413 18.9004 24.7373C18.6999 24.9333 18.4333 25.0312 18.1006 25.0312C17.7725 25.0312 17.5059 24.9333 17.3008 24.7373C17.1003 24.5413 17 24.293 17 23.9922C17 23.6914 17.1003 23.443 17.3008 23.2471C17.5059 23.0465 17.7725 22.9463 18.1006 22.9463Z"
            fill="#DA9000"
        />
        <path
            d="M23.052 21.0464C23.0366 21.5036 22.6615 21.8662 22.2041 21.8662C21.7467 21.8662 21.3716 21.5036 21.3562 21.0464L21.1862 16.0024C21.1672 15.4373 21.6201 14.9688 22.1856 14.9688H22.2226C22.7881 14.9688 23.241 15.4373 23.222 16.0024L23.052 21.0464ZM22.2041 22.9463C22.5368 22.9463 22.8034 23.0443 23.0039 23.2402C23.209 23.4362 23.3115 23.6868 23.3115 23.9922C23.3115 24.293 23.209 24.5413 23.0039 24.7373C22.8034 24.9333 22.5368 25.0312 22.2041 25.0312C21.876 25.0312 21.6094 24.9333 21.4043 24.7373C21.2038 24.5413 21.1035 24.293 21.1035 23.9922C21.1035 23.6914 21.2038 23.443 21.4043 23.2471C21.6094 23.0465 21.876 22.9463 22.2041 22.9463Z"
            fill="#DA9000"
        />
    </svg>
);

export const ncSvg = (
    <svg width="40" height="40" viewBox="8 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="19.959" cy="20" r="11" fill="#B94646" fillOpacity="0.1" stroke="#A20000" strokeWidth="2" />
        <path
            d="M24.0208 24.0176C23.7036 24.3348 23.1893 24.3348 22.872 24.0176L20.1414 21.287C20.0633 21.2089 19.9367 21.2089 19.8586 21.287L17.128 24.0176C16.8107 24.3348 16.2964 24.3348 15.9792 24.0176C15.6619 23.7003 15.6619 23.186 15.9792 22.8688L18.7098 20.1382C18.7879 20.0601 18.7879 19.9334 18.7098 19.8553L15.9792 17.1247C15.6619 16.8075 15.6619 16.2931 15.9792 15.9759C16.2964 15.6587 16.8107 15.6587 17.128 15.9759L19.8586 18.7065C19.9367 18.7846 20.0633 18.7846 20.1414 18.7065L22.872 15.9759C23.1893 15.6587 23.7036 15.6587 24.0208 15.9759C24.3381 16.2931 24.3381 16.8075 24.0208 17.1247L21.2902 19.8553C21.2121 19.9334 21.2121 20.0601 21.2902 20.1382L24.0208 22.8688C24.3381 23.186 24.3381 23.7003 24.0208 24.0176Z"
            fill="#A20000"
        />
    </svg>
);

export const inspectedSvg = (
    <svg width="40" height="40" viewBox="8 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20 30C25.5228 30 30 25.5228 30 20C30 14.4772 25.5228 10 20 10C14.4772 10 10 14.4772 10 20C10 25.5228 14.4772 30 20 30ZM20 32C26.6274 32 32 26.6274 32 20C32 13.3726 26.6274 8 20 8C13.3726 8 8 13.3726 8 20C8 26.6274 13.3726 32 20 32Z"
            fill="#707070"
        />
        <path
            d="M18.1967 22.0857C18.1188 22.1622 17.994 22.1622 17.9162 22.0857L15.9482 20.1496C15.7147 19.9198 15.3401 19.9191 15.1057 20.1481C14.8646 20.3836 14.864 20.7712 15.1042 21.0075L17.9162 23.7739C17.994 23.8504 18.1189 23.8504 18.1967 23.7739L24.8987 17.1806C25.1376 16.9456 25.1376 16.5605 24.8987 16.3255C24.6654 16.0959 24.2911 16.0958 24.0576 16.3253L18.1967 22.0857Z"
            fill="#707070"
        />
    </svg>
);

export const moSvg = (
    <svg width="40" height="40" viewBox="8 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="19.9556" cy="20.0764" r="11" fill="#DA9000" fillOpacity="0.1" />
        <circle cx="19.9556" cy="20.0764" r="11" stroke="#DFBC00" strokeWidth="2" />
        <circle cx="19.9556" cy="20.0764" r="11" stroke="black" strokeOpacity="0.05" strokeWidth="2" />
        <path
            d="M20.8445 21.0464C20.8291 21.5036 20.454 21.8662 19.9966 21.8662C19.5391 21.8662 19.164 21.5036 19.1486 21.0464L18.9787 16.0024C18.9596 15.4373 19.4126 14.9688 19.9781 14.9688H20.0151C20.5805 14.9688 21.0335 15.4373 21.0145 16.0024L20.8445 21.0464ZM19.9966 22.9463C20.3293 22.9463 20.5959 23.0443 20.7964 23.2402C21.0015 23.4362 21.104 23.6868 21.104 23.9922C21.104 24.293 21.0015 24.5413 20.7964 24.7373C20.5959 24.9333 20.3293 25.0312 19.9966 25.0312C19.6685 25.0312 19.4019 24.9333 19.1968 24.7373C18.9963 24.5413 18.896 24.293 18.896 23.9922C18.896 23.6914 18.9963 23.443 19.1968 23.2471C19.4019 23.0465 19.6685 22.9463 19.9966 22.9463Z"
            fill="#DFBC00"
        />
        <path
            d="M20.8445 21.0464C20.8291 21.5036 20.454 21.8662 19.9966 21.8662C19.5391 21.8662 19.164 21.5036 19.1486 21.0464L18.9787 16.0024C18.9596 15.4373 19.4126 14.9688 19.9781 14.9688H20.0151C20.5805 14.9688 21.0335 15.4373 21.0145 16.0024L20.8445 21.0464ZM19.9966 22.9463C20.3293 22.9463 20.5959 23.0443 20.7964 23.2402C21.0015 23.4362 21.104 23.6868 21.104 23.9922C21.104 24.293 21.0015 24.5413 20.7964 24.7373C20.5959 24.9333 20.3293 25.0312 19.9966 25.0312C19.6685 25.0312 19.4019 24.9333 19.1968 24.7373C18.9963 24.5413 18.896 24.293 18.896 23.9922C18.896 23.6914 18.9963 23.443 19.1968 23.2471C19.4019 23.0465 19.6685 22.9463 19.9966 22.9463Z"
            fill="black"
            fillOpacity="0.05"
        />
    </svg>
);

export const cSvg = (
    <svg width="40" height="40" viewBox="8 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="20" cy="20" r="12" fill="#48775B" fillOpacity="0.1" />
        <circle cx="20" cy="20" r="11" stroke="#48775B" strokeOpacity="0.9" strokeWidth="2" />
        <circle cx="19.9997" cy="20.0798" r="2.66667" fill="#48775B" />
    </svg>
);
export const greenCheck: JSX.Element = (
    <svg
        width="40"
        height="40"
        viewBox="8 0 40 40"
        fill="none"
        xmlns="
http://www.w3.org/2000/svg">
        <circle cx="20" cy="20" r="12" fill="#007443" />
        <circle cx="20" cy="20" r="11" stroke="black" strokeOpacity="0.1" strokeWidth="2" />
        <path
            d="M18.1967 22.1739C18.1188 22.2504 17.994 22.2503 17.9162 22.1738L15.9482 20.2377C15.7147 20.0079 15.3401 20.0073 15.1057 20.2362C14.8646 20.4717 14.864 20.8593 15.1042 21.0957L17.9162 23.862C17.994 23.9386 18.1189 23.9386 18.1967 23.862L24.8987 17.2687C25.1376 17.0337 25.1376 16.6486 24.8987 16.4136C24.6654 16.1841 24.2911 16.184 24.0576 16.4134L18.1967 22.1739Z"
            fill="white"
        />
    </svg>
);

export const unavailable: JSX.Element = (
    <svg width="41" height="41" viewBox="8 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.8027 30.3384C26.3256 30.3384 30.8027 25.8612 30.8027 20.3384C30.8027 14.8155 26.3256 10.3384 20.8027 10.3384C15.2799 10.3384 10.8027 14.8155 10.8027 20.3384C10.8027 25.8612 15.2799 30.3384 20.8027 30.3384ZM20.8027 32.3384C27.4302 32.3384 32.8027 26.9658 32.8027 20.3384C32.8027 13.711 27.4302 8.33838 20.8027 8.33838C14.1753 8.33838 8.80273 13.711 8.80273 20.3384C8.80273 26.9658 14.1753 32.3384 20.8027 32.3384Z"
            fill="#B0B0B0"
        />
        <path d="M15.8027 20.25L25.8027 20.25" stroke="#B0B0B0" strokeWidth="2" strokeLinecap="round" />
    </svg>
);

export const immediateDanger: JSX.Element = (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_18346_15365)">
            <path
                d="M0.901199 27.1694C0.484213 27.8355 0.962996 28.7001 1.74878 28.7001H22.137C22.9227 28.7001 23.4015 27.8355 22.9845 27.1694L12.7905 10.8872C12.3987 10.2614 11.4871 10.2614 11.0953 10.8872L0.901199 27.1694ZM13.0338 24.665C13.0338 25.2173 12.5861 25.6738 12.0338 25.6738H11.852C11.2997 25.6738 10.852 25.2173 10.852 24.665C10.852 24.1127 11.2997 23.6563 11.852 23.6563H12.0338C12.5861 23.6563 13.0338 24.1127 13.0338 24.665ZM13.0338 21.5001C13.0338 22.0524 12.5861 22.5001 12.0338 22.5001H11.852C11.2997 22.5001 10.852 22.0524 10.852 21.5001V17.3258C10.852 16.7736 11.2997 16.3258 11.852 16.3258H12.0338C12.5861 16.3258 13.0338 16.7736 13.0338 17.3258V21.5001Z"
                fill="#A20000"
            />
        </g>
        <defs>
            <clipPath id="clip0_18346_15365">
                <rect width="40" height="40" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const infoIcon: JSX.Element = (
  <svg width="20" height="20" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10" cy="10.5" r="9.5" fill="#F2F9F9" stroke="#00818A" />
    <path
      d="M10.9214 14.3747C10.9205 14.8821 10.5089 15.293 10.0015 15.293C9.49284 15.293 9.08073 14.8802 9.08162 14.3715L9.08898 10.124C9.08986 9.61654 9.50146 9.20566 10.0089 9.20566C10.5175 9.20566 10.9297 9.61848 10.9288 10.1271L10.9214 14.3747ZM8.97217 6.65231C8.97217 6.37739 9.0631 6.15112 9.24497 5.97348C9.43106 5.79585 9.68271 5.70703 9.99992 5.70703C10.3129 5.70703 10.5624 5.79585 10.7485 5.97348C10.9346 6.15112 11.0277 6.37739 11.0277 6.65231C11.0277 6.93145 10.9325 7.15983 10.7422 7.33747C10.5561 7.51511 10.3087 7.60392 9.99992 7.60392C9.69117 7.60392 9.44163 7.51511 9.25131 7.33747C9.06522 7.15983 8.97217 6.93145 8.97217 6.65231Z"
      fill="#00818A"
    />
  </svg>
);